module.exports = __webpack_public_path__ + "img/Group-1984.016c5882.png";